import { useState, useEffect } from 'react';

const useWindow = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    if (width !== window.innerWidth) {
      setWidth(window.innerWidth);
    }

    if (height !== window.innerHeight) {
      setHeight(window.innerHeight);
    }
  }, [window.innerWidth, window.innerHeight]);

  return { width, height };
};

export default useWindow;
